import { render, staticRenderFns } from "./Notificationrule.vue?vue&type=template&id=73fc8edb&"
import script from "./Notificationrule.vue?vue&type=script&lang=js&"
export * from "./Notificationrule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports